module.exports = __webpack_public_path__ + "img/red_069.06159b4d.png";